import { useEffect, useState } from "react";
import { obtenerImagenesCarousel } from '../firestore';
import { ICONS } from "../assets/icons";
import { useNavigate } from "react-router";


function CarouselHome() {

    const navigate = useNavigate();
    const [itemsCarousel, setItemsCarousel] = useState([]);
    const [currentItemIndex, setCurrentItemIndex] = useState(0);

    useEffect(() => {
        cargarImagenesCarousel();
    }, []);


    async function cargarImagenesCarousel() {
        const imagenes = await obtenerImagenesCarousel();
        if (imagenes.length) {
            setCurrentItemIndex(0);
        }
        setItemsCarousel(imagenes);
    }

    useEffect(() => {
        // Si no hay imágenes, no hacemos nada
        if (!itemsCarousel.length) return;

        // Configuramos el temporizador
        const timer = setTimeout(() => {
            // Usamos la misma lógica de "siguiente" que en tu onClick
            const newIndex = currentItemIndex === itemsCarousel.length - 1 ? 0 : currentItemIndex + 1;
            setCurrentItemIndex(newIndex);
        }, 4000); // 4 segundos

        // IMPORTANTE: Esta función limpia el timer anterior cuando
        // currentItemIndex cambia (por click o por tiempo) o el componente se desmonta.
        return () => clearTimeout(timer);

    }, [currentItemIndex, itemsCarousel]);


    return (
        <div className="row" style={{ paddingLeft: '2rem', paddingRight: '2rem', background: '#f6fbfd' }}>

            <div className="col s12 mt-2 mb-2">
                <img src={ICONS.txtSaludFinanciera} alt="Salud Financiera"  />
            </div>

            <div className="col s12 m3" style={{paddingTop: '1rem'}}>
                <div className="row cardCarousel ">
                    <div className="col s12 mt-1">
                        <img src={ICONS.calculaPension} alt="Calcula tu Pensión" style={{ width: '100%' }} />
                    </div>
                    <div className="col s12">
                        <img src={ICONS.conoceMas} className="cursorPointer" alt="Conoce Más" style={{ width: '100px' }} 
                        onClick={()=>{
                            navigate('/calcular_retiro_s')
                        }}
                        />
                    </div>
                </div>
            </div>

            <div className="col s12 m6">


                {
                    itemsCarousel.length ?
                        <div className="row carousel-row">
                            <div className="col s12 carousel-container">
                                <img
                                    src={ICONS.leftArrow}
                                    className="carousel-arrow carousel-arrow-left responsive-img" 
                                    alt="Left Arrow"
                                    onClick={() => {
                                        const newIndex = currentItemIndex === 0 ? itemsCarousel.length - 1 : currentItemIndex - 1;
                                        setCurrentItemIndex(newIndex);
                                    }}
                                />
                                <img
                                    src={itemsCarousel[currentItemIndex].url}
                                    alt={`Carousel Item ${currentItemIndex + 1}`}
                                    style={{ width: '100%' }}
                                />

                                <img
                                    src={ICONS.rightArrow}
                                    className="carousel-arrow carousel-arrow-right responsive-img"
                                    alt="Right Arrow"
                                    onClick={() => {
                                        const newIndex = currentItemIndex === itemsCarousel.length - 1 ? 0 : currentItemIndex + 1;
                                        setCurrentItemIndex(newIndex);
                                    }}
                                />
                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                    {itemsCarousel.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentItemIndex(index)}
                                            style={{
                                                margin: '0 5px',
                                                padding: '5px 10px',
                                                backgroundColor: index === currentItemIndex ? '#41BBC9' : '#41BBC94D',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '50%',
                                                cursor: 'pointer',
                                                width: '40px',
                                                height: '6px',
                                                borderRadius: '4px'
                                            }}
                                        >

                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        : null
                }

            </div>

            <div className="col s12 m3"  style={{paddingTop: '1rem'}}>
                <div className="row cardCarousel">
                    <div className="col s12 mt-1">
                        <img src={ICONS.educacionFinanciera} alt="Calcula tu Pensión" style={{ width: '100%' }} />
                    </div>
                    <div className="col s12">
                        <img src={ICONS.conoceMas} className="cursorPointer" alt="Conoce Más" style={{ width: '100px' }}
                        onClick={()=>{
                             navigate('/educacion_financiera_s')
                        }}
                        />
                    </div>
                </div>
            </div>


        </div>
    )

}

export default CarouselHome;